/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AutosavePalAuthSubmission200ResponseData } from './AutosavePalAuthSubmission200ResponseData';
import {
    AutosavePalAuthSubmission200ResponseDataFromJSON,
    AutosavePalAuthSubmission200ResponseDataFromJSONTyped,
    AutosavePalAuthSubmission200ResponseDataToJSON,
} from './AutosavePalAuthSubmission200ResponseData';

/**
 *
 * @export
 * @interface AutosavePalAuthSubmission200Response
 */
export interface AutosavePalAuthSubmission200Response {
    /**
     *
     * @type {AutosavePalAuthSubmission200ResponseData}
     * @memberof AutosavePalAuthSubmission200Response
     */
    data?: AutosavePalAuthSubmission200ResponseData;
}

/**
 * Check if a given object implements the AutosavePalAuthSubmission200Response interface.
 */
export function instanceOfAutosavePalAuthSubmission200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AutosavePalAuthSubmission200ResponseFromJSON(json: any): AutosavePalAuthSubmission200Response {
    return AutosavePalAuthSubmission200ResponseFromJSONTyped(json, false);
}

export function AutosavePalAuthSubmission200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AutosavePalAuthSubmission200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'data': !exists(json, 'data') ? undefined : AutosavePalAuthSubmission200ResponseDataFromJSON(json['data']),
    };
}

export function AutosavePalAuthSubmission200ResponseToJSON(value?: AutosavePalAuthSubmission200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'data': AutosavePalAuthSubmission200ResponseDataToJSON(value.data),
    };
}

